// import Sticky from 'react-stickynode';
// import { ThemeProvider } from 'styled-components';
// import Navbar from '../containers/SaasModern/Navbar';
// import Footer from '../containers/SaasModern/Footer';
// import FaqSection from '../containers/SaasModern/Faq';
// import { ResetCSS } from 'common/src/assets/css/style';
// import ControllSection from '../containers/App/Control';
// import InfoSection from '../containers/SaasModern/Info';
// import TrialSection from '../containers/SaasModern/Trial';
// import Transactions from '../containers/Crypto/Transaction';
// import FeatureSlider from '../containers/App/FeatureSlider';
// import PricingSection from '../containers/SaasModern/Pricing';
// import PartnerHistory from '../containers/App/PartnerHistory';
// import { saasModernTheme } from 'common/src/theme/saasModern';
// import PaymentSection from '../containers/App/PaymentSection';
// import TestimonialSection from '../containers/App/Testimonial';
// import { ConditionWrapper } from '../containers/App/app.style';
// import FeatureSliderTwo from '../containers/App/FeatureSliderTwo';
// import { DrawerProvider } from 'common/src/contexts/DrawerContext';
// import WorkingProcessSection from '../containers/SaasModern/WorkingProcess';
// import { GlobalStyle, ContentWrapper } from '../containers/SaasModern/sassModern.style';

// import FeatureSection from '../containers/SaasModern/Feature';
// import FeatureSection from '../containers/App/FeatureSection';
// import FeatureSection from '../containers/SaasClassic/Feature';
// import UpdateScreen from '../containers/SaasModern/UpdateScreen';
// import TestimonialSection from '../containers/SaasModern/Testimonial';

// imports
import React /*, { useState, useEffect, Fragment }*/ from 'react';

import SEO from '../components/seo';
import Layout from '../components/layout';
import Metrics from '../containers/Fizz/Metrics';
import Features from '../containers/AppClassic/Features';
import JoinTrail from '../containers/AppClassic/JoinTrail';
import BannerSection from '../containers/SaasModern/Banner';
import PartnerSection from '../containers/SaasModern/Partner';
import CodeSnippetPanel from '../containers/Fizz/CodeSnippetPanel';
import SolutionPackages from '../containers/SaasClassic/UpdateScreen';

// helper methods
// function getSize() {
//   return {
//     innerHeight: window.innerHeight,
//     innerWidth: window.innerWidth,
//     outerHeight: window.outerHeight,
//     outerWidth: window.outerWidth,
//   };
// }

// function useWindowSize() {
//   let [windowSize, setWindowSize] = useState(getSize());

//   function handleResize() {
//     setWindowSize(getSize());
//   }

//   useEffect(() => {
//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);

//   return windowSize;
// }

// exports
export default () => {
  // const size = process.browser && useWindowSize();
  // const innerWidth = process.browser && size.innerWidth;
  return (
    <Layout>
      <SEO title='Free Customizable Chat Messaging Platform, Chat SDK and API for Mobile and PC Games and Apps | Fizz.io' />
      <BannerSection />
      <PartnerSection />
      {/* <section style={{ height: 200, backgroundColor: 'beige' }}> Metrics Section </section> */}
      {/* <section> Developer Box </section> */}
      {/* <WorkingProcessSection /> */}
      {/* <InfoSection /> */}
      {/* <Transactions /> */}
      {/* <ControllSection /> */}
      {/* <ConditionWrapper id='feature_section'>
        {innerWidth > 1100 ? <FeatureSlider /> : <FeatureSliderTwo />}
      </ConditionWrapper> */}
      {/* <PartnerHistory /> */}
      {/* <PaymentSection /> */}
      <Metrics />
      <Features />
      <SolutionPackages />
      <CodeSnippetPanel />
      <JoinTrail />
      {/* <PricingSection /> */}
      {/* <TestimonialSection /> */}
      {/* <FaqSection /> */}
      {/* <TrialSection /> */}
    </Layout>
  );
};